import {
  DistributorFeeSourceApproved,
  DistributorFeeSourceRejected,
  DistributorFeeStatusCreated,
  DistributorFeeStatusFinanceAdjusted,
  DistributorFeeStatusFinanceConfirmed,
} from 'utils/distributorFee'

export const DISTRIBUTOR_FEE_EN = {
  [DistributorFeeStatusCreated]: 'Created',
  [DistributorFeeStatusFinanceAdjusted]: 'Finance Adjusted',
  [DistributorFeeStatusFinanceConfirmed]: 'Finance Confirmed',
  [DistributorFeeSourceApproved]: 'Source Approved',
  [DistributorFeeSourceRejected]: 'Source Rejected',
}
